import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { ModalType } from '../../components/modals/constants';

export interface ModalEntry {
  id: string;
  modalType: ModalType;
  modalProps: Record<string, any>;
}

export type ModalState = ModalEntry[];

const initialState: ModalState = [];

export const modalSlice = createSlice({
  name: 'modals',
  initialState,
  reducers: {
    pushModal: {
      reducer(state, action: PayloadAction<ModalEntry>) {
        state.push(action.payload);
      },
      prepare({
        modalType,
        modalProps = {},
      }: {
        modalType: ModalType;
        modalProps?: Record<string, any>;
      }) {
        return {
          payload: {
            id: Date.now().toString(),
            modalType,
            modalProps,
          },
        };
      },
    },
    popModal(state) {
      state.pop();
    },
    clearModals() {
      return [];
    },
  },
});

export const { pushModal, popModal, clearModals } = modalSlice.actions;
export default modalSlice.reducer;
